/**
 * Maintains a list of registered screens. Example: [
      "/clients-list",
      "/users",
      "/configurations/emailTemplate",
      "/configurations/emailSnippet"
    ]
  * If a screen is registered, it means that the screen is configured to use the loading context.
 */
class ScreenStatusRegistry {
  private static instance: ScreenStatusRegistry;
  private list: Array<string>;

  private constructor() {
    this.list = [];
  }

  public static getInstance(): ScreenStatusRegistry {
    if (!ScreenStatusRegistry.instance) {
      ScreenStatusRegistry.instance = new ScreenStatusRegistry();
    }
    return ScreenStatusRegistry.instance;
  }

  public getAll(): Array<string> {
    return this.list;
  }

  public isScreenRegistered(path: string): boolean {
    return this.list.includes(path);
  }

  public register(path: string): void {
    if (!this.isScreenRegistered(path)) {
      this.list.push(path);
    }
  }
}

export const screenStatusRegistry = ScreenStatusRegistry.getInstance();
